<template>
    <div class="image-upload">
        <picture-input
            ref="pictureInput"
            width="240"
            height="180"
            margin="16"
            accept="image/jpeg,image/png"
            size="12"
            button-class="btn"
            @change="onChange">
        </picture-input>
    </div>
</template>

<script>
import PictureInput from 'vue-picture-input';
import {conversion} from '@/mixins/conversion';
export default {
    data : function () {
        return {
            image : null
        }
    },
    mixins : [conversion],
    components : {
        PictureInput
    },
    props : {
        setMedia : Function,
        dataUrl  : {
            type : Boolean,
            default : false
        }
    },
    methods : {
        onChange : function (img) {
            if (this.dataUrl) {
                this.setMedia(img);
            } else {
                var blob = this.dataURItoBlob(img);
                this.setMedia(blob);
            }
        }
    }
}
</script>

<style>
.image-upload .picture-input .picture-preview {
    height : 120px !important;
    width : 120px !important;
    border-radius : 60px;
    object-fit : cover;
    margin: 20px auto 5px;
}
</style>